import ApiSystemRepository from '../Repositories/System/ApiSystemRepository';
import type { BaseSystemRepository } from '../Repositories/System/BaseSystemRepository.interface';

type SystemServiceServiceType = 'api' | 'experimental';

class SystemService {
  private type: SystemServiceServiceType = 'api';
  private Repository!: BaseSystemRepository;

  constructor(type: SystemServiceServiceType) {
    this.type = type;
    this.assignRepository();
  }

  private assignRepository() {
    switch (this.type) {
      case 'api':
        this.Repository = new ApiSystemRepository();
        break;
      default:
        this.Repository = new ApiSystemRepository();
    }
  }

  async keepAlive(): Promise<boolean> {
    return await this.Repository.keepAlive();
  }
}

export default SystemService;
